import React from 'react';
import styles from '../../styles/effects/CloudEffect.module.scss';

const CloudEffect: React.FC = () => {
  const clouds = Array.from({ length: 30 }).map((_, i) => {
    const top = Math.random() * 65; // only in top 65%
    const width = 50 + Math.random() * 50; // 50%–100% wide
    const height = 30 + Math.random() * 70; // 30px–100px tall
    const duration = 30 + Math.random() * 30; // 30s–60s across
    const delay = -Math.random() * duration; // staggered start
    const opacity = 0.5 + Math.random() * 0.3; // 0.5–0.8 opacity

    return (
      <div
        key={i}
        className={styles.cloud}
        style={
          {
            top: `${top}%`,
            width: `${width}%`,
            height: `${height}px`,
            opacity,
            animationDuration: `${duration}s`,
            animationDelay: `${delay}s`,
          } as React.CSSProperties
        }
      />
    );
  });

  return <div className={styles.clouds}>{clouds}</div>;
};

export default CloudEffect;
